import { PropostaVisualizacao } from "../../../components/proposta/visualizacao/Visualizacao";

export const VisualizacaoPropostaPage = () => {
    return (
        <div style={{
            margin: "auto"
        }}>
            <PropostaVisualizacao />
        </div>
    );
}